const menuStack = [];
const mainFirstLevelNav = document.querySelector("#menu-level-1");

const secondaryMenu = document.querySelector(".mobile-nav-content__secondary-menu");
const bottomUtilityBar = document.querySelector(".mobile-nav-content .utility-bar__mobile-nav");

document.querySelectorAll(".navmenu-link[data-subnav-target]").forEach((link) => {
    link.addEventListener("click", (e) => {
        e.preventDefault();
        const currentLevel = link.closest(".navmenu-level");
        const targetId = link.getAttribute("data-subnav-target");
        const targetLevel = document.getElementById(targetId);

        if (targetLevel) {
            menuStack.push(currentLevel);

            const parentTitle = link.getAttribute("data-parent-title");
            const backButton = targetLevel.querySelector(".navmenu-back-button span");
            if (backButton) {
                backButton.textContent = `${parentTitle}`;
            }

            currentLevel.classList.remove("active");
            currentLevel.setAttribute("aria-hidden", "true");
            targetLevel.classList.add("active");
            targetLevel.setAttribute("aria-hidden", "false");

            secondaryMenu.classList.add("nav-hide-xx");
            if(bottomUtilityBar){ bottomUtilityBar.classList.add("nav-hide-xx"); }

        }
    });
});

document.querySelectorAll(".navmenu-back-button").forEach((button) => {
    button.addEventListener("click", () => {
        const currentLevel = button.closest(".navmenu-level");

        const previousLevel = menuStack.pop();

        if (previousLevel) {
            currentLevel.classList.remove("active");
            currentLevel.setAttribute("aria-hidden", "true");
            previousLevel.classList.add("active");
            previousLevel.setAttribute("aria-hidden", "false");
        } else {
            currentLevel.classList.remove("active");
            currentLevel.setAttribute("aria-hidden", "true");
            document.getElementById("menu-level-1").classList.add("active");
            document.getElementById("menu-level-1").setAttribute("aria-hidden", "false");
        }

        const mainFirstLevelNavAttr = mainFirstLevelNav.getAttribute("aria-hidden");
        if (mainFirstLevelNavAttr === "false") {
            secondaryMenu.classList.remove("nav-hide-xx");
            if(bottomUtilityBar){ bottomUtilityBar.classList.remove("nav-hide-xx"); }

        }

    });
});

document.querySelectorAll('.navmenu-back-to-main').forEach(button => {
    button.addEventListener('click', () => {
        document.querySelectorAll('.navmenu-level').forEach(menu => {
            menu.classList.remove('active');
            menu.setAttribute('aria-hidden', 'true');
        });

        const mainMenu = document.getElementById('menu-level-1');
        mainMenu.classList.add('active');
        mainMenu.setAttribute('aria-hidden', 'false');

        const mainFirstLevelNavAttr = mainFirstLevelNav.getAttribute("aria-hidden");
        if (mainFirstLevelNavAttr === "false") {
            secondaryMenu.classList.remove("nav-hide-xx");
            if(bottomUtilityBar){ bottomUtilityBar.classList.remove("nav-hide-xx"); }

        }

    });

});

